import { Nav } from "react-bootstrap";

export default function PricelistVatItem({ id, title }) {
  return (
    <Nav.Item key={`pricelist-nav-item-${id}`}>
      <Nav.Link eventKey={`pricelist-nav-item-${id}`}>{title}</Nav.Link>
    </Nav.Item>
  );
}
